import { render } from "./NewsDetailsView.vue?vue&type=template&id=549ffa82"
import script from "./NewsDetailsView.vue?vue&type=script&lang=js"
export * from "./NewsDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__